'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n    width: 100%;\n    margin-top: 0;\n    background-color: ', ';\n    padding-bottom: 3.4em;\n  '], ['\n    width: 100%;\n    margin-top: 0;\n    background-color: ', ';\n    padding-bottom: 3.4em;\n  ']),
    _templateObject2 = _taggedTemplateLiteral(['\n    width: 100%;\n  '], ['\n    width: 100%;\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n    padding: 0 1em;\n    margin-top: 3.1em;\n  '], ['\n    padding: 0 1em;\n    margin-top: 3.1em;\n  ']),
    _templateObject4 = _taggedTemplateLiteral(['\n      text-align: left;\n      margin-bottom: .93em;\n    '], ['\n      text-align: left;\n      margin-bottom: .93em;\n    ']),
    _templateObject5 = _taggedTemplateLiteral(['\n    padding: 0 0.45em;\n    text-align: left;\n  '], ['\n    padding: 0 0.45em;\n    text-align: left;\n  ']),
    _templateObject6 = _taggedTemplateLiteral(['\n    width: 90%;\n  '], ['\n    width: 90%;\n  ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _H = require('UIComponents/elements/headings/H1');

var _H2 = _interopRequireDefault(_H);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _FeaturesSection = require('pricing-pages-unified-ui/components/free-tools-page/FeaturesSection');

var _FeaturesSection2 = _interopRequireDefault(_FeaturesSection);

var _GuaranteeSection = require('pricing-pages-unified-ui/components/free-tools-page/GuaranteeSection');

var _GuaranteeSection2 = _interopRequireDefault(_GuaranteeSection);

var _FeaturesModal = require('pricing-pages-unified-ui/components/free-tools-page/FeaturesModal');

var _FeaturesModal2 = _interopRequireDefault(_FeaturesModal);

var _Breakpoints = require('pricing-pages-unified-ui/constants/Breakpoints');

var _FooterMicrocopy = require('pricing-pages-unified-ui/components/common/FooterMicrocopy');

var _FooterMicrocopy2 = _interopRequireDefault(_FooterMicrocopy);

var _getUsageTracker = require('pricing-pages-unified-ui/utils/getUsageTracker');

var _getUsageTracker2 = _interopRequireDefault(_getUsageTracker);

var _Tracking = require('pricing-pages-unified-ui/constants/Tracking');

var _Question = require('pricing-pages-unified-ui/static/js/components/common/Question');

var _Question2 = _interopRequireDefault(_Question);

var _reactRouterDom = require('react-router-dom');

var _reactRhumb = require('react-rhumb');

var _TabLayout = require('../TabLayout');

var _TabLayout2 = _interopRequireDefault(_TabLayout);

var _urls = require('pricing-pages-unified-ui/utils/urls');

var _responsiveBreakpoints = require('../../utils/responsiveBreakpoints');

var _responsiveBreakpoints2 = _interopRequireDefault(_responsiveBreakpoints);

var _EnvironmentWrapper = require('pricing-pages-unified-ui/components/EnvironmentWrapper');

var _EnvironmentWrapper2 = _interopRequireDefault(_EnvironmentWrapper);

var _SignupButton = require('pricing-pages-unified-ui/components/public-only/SignupButton');

var _SignupButton2 = _interopRequireDefault(_SignupButton);

var _DocumentUtils = require('pricing-pages-unified-ui/static/js/utils/DocumentUtils');

var _PhoneSupport = require('pricing-pages-unified-ui/components/common/PhoneSupport');

var _PhoneSupport2 = _interopRequireDefault(_PhoneSupport);

var _colors = require('HubStyleTokens/colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Container = _styledComponents2.default.div.withConfig({
  displayName: 'FreeToolsPage__Container'
})(['background-color:white;display:flex;align-items:center;flex-direction:column;overflow:hidden;width:100%;position:relative;']);

var MainHeader = (0, _styledComponents2.default)(_FormattedMessage2.default).withConfig({
  displayName: 'FreeToolsPage__MainHeader'
})(['text-align:center;font-weight:600;font-size:32px;margin-bottom:8px;line-height:40px;@media (max-width:', 'px){font-size:29px;}'], _Breakpoints.FEATURES_SECTION);

var SubHeader = (0, _styledComponents2.default)(_FormattedMessage2.default).withConfig({
  displayName: 'FreeToolsPage__SubHeader'
})(['font-weight:300;font-size:14px;text-align:center;max-width:600px;margin-bottom:40px;@media (max-width:', 'px){font-size:16px;}'], _Breakpoints.FEATURES_SECTION);

var PhoneSupportWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'FreeToolsPage__PhoneSupportWrapper'
})(['width:450px;margin-top:40px;', ''], _responsiveBreakpoints2.default.phone(_templateObject, _colors.GYPSUM));

var FaqContainer = _styledComponents2.default.div.withConfig({
  displayName: 'FreeToolsPage__FaqContainer'
})(['width:950px;margin-right:auto;margin-left:auto;padding-top:40px;clear:both;', ' ', ';.faq-header{text-align:center;', '}'], _responsiveBreakpoints2.default.tablet(_templateObject2), _responsiveBreakpoints2.default.phone(_templateObject3), _responsiveBreakpoints2.default.phone(_templateObject4));

var Taglines = (0, _styledComponents2.default)(_H2.default).withConfig({
  displayName: 'FreeToolsPage__Taglines'
})(['text-align:center;margin:1.55em 0 0.74em;', ' .tagline{display:block;}'], _responsiveBreakpoints2.default.phone(_templateObject5));

var SignupButtonWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'FreeToolsPage__SignupButtonWrapper'
})(['', ''], _responsiveBreakpoints2.default.phone(_templateObject6));

var FreeToolsPage = function (_Component) {
  _inherits(FreeToolsPage, _Component);

  function FreeToolsPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FreeToolsPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FreeToolsPage.__proto__ || Object.getPrototypeOf(FreeToolsPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      currentState: 'INITIAL'
    }, _this.onViewMore = function (header, features, hubType, merchandiseId) {
      return function () {
        return _this.setState({
          currentState: 'SHOW_MODAL',
          header: header,
          features: features,
          hubType: hubType,
          merchandiseId: merchandiseId
        });
      };
    }, _this.onModalClose = function () {
      return _this.setState({ currentState: 'INITIAL', header: null, features: null });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FreeToolsPage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      (0, _getUsageTracker2.default)().track('pageView', {
        screen: _Tracking.SCREENS.PRODUCTS_PLANS,
        subscreen: _Tracking.SUBSCREENS.FREE_TOOLS_CRM
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          header = _state.header,
          features = _state.features,
          merchandiseId = _state.merchandiseId,
          hubType = _state.hubType,
          currentState = _state.currentState;


      return _react2.default.createElement(
        _TabLayout2.default,
        { selectedPrimaryTab: 'products', selectedSecondaryTab: 'crm' },
        _react2.default.createElement(
          Container,
          { 'data-selenium-id': 'page-success' },
          _react2.default.createElement(_reactRhumb.NavMarker, { name: 'FREE_TOOLS_PAGE' }),
          _react2.default.createElement(
            'div',
            {
              className: 'display-flex align-center flex-column m-top-10 p-x-4',
              style: { maxWidth: '800px' }
            },
            _react2.default.createElement(MainHeader, { message: 'pricingPage.pages.crm.mainHeader' }),
            _react2.default.createElement(SubHeader, { message: 'pricingPage.pages.crm.subHeader' }),
            _react2.default.createElement(_EnvironmentWrapper2.default, {
              publicNode: _react2.default.createElement(_SignupButton2.default, {
                sourceId: 'crm-pricing-hero',
                className: 'm-bottom-5 p-x-9 p-y-5'
              })
            })
          ),
          _react2.default.createElement(_FeaturesSection2.default, { onViewMore: this.onViewMore }),
          _react2.default.createElement(_GuaranteeSection2.default, null),
          _react2.default.createElement(
            PhoneSupportWrapper,
            null,
            _react2.default.createElement(_PhoneSupport2.default, {
              phoneSourceId: 'crm-middle',
              screen: _Tracking.SUBSCREENS.FREE_TOOLS_CRM
            })
          ),
          _react2.default.createElement(
            FaqContainer,
            null,
            _react2.default.createElement(
              _H2.default,
              { className: 'faq-header' },
              _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.faq.title' })
            ),
            _react2.default.createElement(_Question2.default, { questionKey: 'free.crmReallyFree' }),
            _react2.default.createElement(_Question2.default, { questionKey: 'free.crmPaidComponentsExist' }),
            _react2.default.createElement(_Question2.default, { questionKey: 'free.crmIntegrateEmail' }),
            _react2.default.createElement(_Question2.default, { questionKey: 'free.crmWithAllHubs' }),
            _react2.default.createElement(_Question2.default, {
              questionKey: 'free.crmAvailableSupport',
              href: (0, _urls.getCommunityUrl)()
            }),
            _react2.default.createElement(_Question2.default, { questionKey: 'free.crmUserCountAndDefinition' })
          ),
          _react2.default.createElement(_FooterMicrocopy2.default, null),
          _react2.default.createElement(_EnvironmentWrapper2.default, {
            publicNode: _react2.default.createElement(
              _react.Fragment,
              null,
              _react2.default.createElement(
                Taglines,
                null,
                _react2.default.createElement(_FormattedMessage2.default, {
                  className: 'tagline',
                  message: 'pricingPage.pages.crm.tagline1'
                }),
                _react2.default.createElement(_FormattedMessage2.default, {
                  className: 'tagline',
                  message: 'pricingPage.pages.crm.tagline2'
                })
              ),
              _react2.default.createElement(
                SignupButtonWrapper,
                null,
                _react2.default.createElement(_SignupButton2.default, {
                  sourceId: 'crm-pricing-bottom',
                  className: 'm-bottom-8'
                })
              )
            )
          })
        ),
        currentState === 'SHOW_MODAL' && _react2.default.createElement(_FeaturesModal2.default, {
          header: header,
          features: features,
          hubType: hubType,
          merchandiseId: merchandiseId,
          onModalClose: this.onModalClose
        })
      );
    }
  }]);

  return FreeToolsPage;
}(_react.Component);

exports.default = (0, _reactRouterDom.withRouter)((0, _DocumentUtils.withDocumentTitle)(FreeToolsPage, 'free'));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/free-tools-page/FreeToolsPage.js
// module id = 642
// module chunks = 3 4